// Central AudioManager (singleton). ONE owner of all playback.
// Rules: welcome loop = landing only · sonic = dashboard once/session · tour loop = tour only · season = story only.
// Starting any loop kills the others. Everything cleans up when its owner unmounts.
const els = {};
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());
const isMuted = () => localStorage.getItem("am_muted") === "1";

// Autoplay is blocked until the first user gesture. Arm a one-time listener to retry playback.
let _armed = false;
function armOnce(fn) {
  if (_armed) return;
  _armed = true;
  const evts = ["pointerdown", "touchstart", "keydown", "click"];
  const handler = () => { _armed = false; evts.forEach((e) => window.removeEventListener(e, handler)); fn(); };
  evts.forEach((e) => window.addEventListener(e, handler, { once: true, passive: true }));
}

function get(name, src, loop, vol) {
  if (!els[name]) { els[name] = new Audio(src); els[name].loop = loop; els[name].volume = vol; }
  return els[name];
}
function fade(el, to, ms = 500) {
  if (!el) return;
  const from = el.volume, steps = 16, dt = ms / steps;
  let i = 0;
  const id = setInterval(() => {
    i += 1;
    el.volume = Math.max(0, Math.min(1, from + (to - from) * (i / steps)));
    if (i >= steps) { clearInterval(id); if (to === 0) { try { el.pause(); } catch { /* */ } } }
  }, dt);
}
const LOOPS = ["welcome", "tour", "season"];
function stopLoops(except) {
  LOOPS.forEach((n) => { if (n !== except && els[n] && !els[n].paused) fade(els[n], 0, 400); });
}

export const audio = {
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
  isMuted,
  isPlaying: () => !isMuted() && LOOPS.some((n) => els[n] && !els[n].paused),

  // WELCOME — landing page only
  playWelcome() {
    if (isMuted()) return;
    stopLoops("welcome");
    const el = get("welcome", "/audio/welcome.mp3", true, 0);
    el.volume = 0;
    el.play().then(() => { fade(el, 0.25, 1000); notify(); }).catch(() => { armOnce(() => audio.playWelcome()); });
  },
  stopWelcome() { if (els.welcome) fade(els.welcome, 0, 500); notify(); },

  // SONIC LOGO — 3s, once per session, on dashboard entry
  playSonic() {
    if (isMuted() || sessionStorage.getItem("sonicPlayed")) return;
    try {
      const a = new Audio("/audio/intro.mp3"); a.volume = 0.7;
      a.play().then(() => sessionStorage.setItem("sonicPlayed", "1")).catch(() => armOnce(() => audio.playSonic()));
    } catch { /* */ }
  },

  // TOUR — loops only while guided tour runs
  playTour() { if (isMuted()) return; stopLoops("tour"); const el = get("tour", "/audio/tour.mp3", true, 0.3); el.currentTime = 0; el.play().then(notify).catch(() => {}); },
  stopTour() { if (els.tour) fade(els.tour, 0, 400); notify(); },

  // SEASON — only inside the wrapped story (off by default; toggled)
  playSeason() { if (isMuted()) return; stopLoops("season"); const el = get("season", "/audio/welcome.mp3", true, 0.2); el.currentTime = 0; el.play().then(notify).catch(() => {}); },
  stopSeason() { if (els.season) fade(els.season, 0, 300); notify(); },

  stopAll() { stopLoops(); notify(); },
  toggleMute() {
    const next = !isMuted();
    localStorage.setItem("am_muted", next ? "1" : "0");
    if (next) stopLoops();
    notify();
    return next;
  },
};
